import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "@/components/ui";
import { Code } from "@/components/ui/Code";
import { config } from "@/utils/config";
function ResolveTokenDetails({ resolveToken }) {
    const [copySuccess, setCopySuccess] = useState(false);
    const url = new URL('/direct/resolve', config.apiUrl);
    url.searchParams.set('token', resolveToken.token);
    const resolveLink = url.toString();
    async function handleCopyToClipboard() {
        try {
            await navigator.clipboard.writeText(resolveLink);
            setCopySuccess(true);
            setTimeout(()=>setCopySuccess(false), 2000);
        } catch  {
            setCopySuccess(false);
        }
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mb-4 rounded-md border border-yellow-200 bg-yellow-50 p-4",
                children: /*#__PURE__*/ _jsxs("p", {
                    className: "text-sm text-yellow-800",
                    children: [
                        /*#__PURE__*/ _jsx("strong", {
                            children: "Important:"
                        }),
                        " Send the signup link below to the customer. They will need it to sign up."
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        className: "mb-2 block text-sm font-medium text-gray-700",
                        children: "Signup Link"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ _jsx(Code, {
                                className: "!mb-0",
                                children: resolveLink
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "text-xs text-gray-500",
                                        children: [
                                            "Expires: ",
                                            new Date(resolveToken.expiresAt).toLocaleString()
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "simple",
                                        color: "navy-90",
                                        onClick: handleCopyToClipboard,
                                        children: copySuccess ? 'Copied!' : 'Copy Link'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export { ResolveTokenDetails };
